// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MNJS","name":"styles_name__51J0y","phone":"styles_phone__3_SEH"};